/* Keep Deliver to aligned with the current IP, while manual choices always win. */
(() => {
  if (window.mangofyDeliveryInitialized) return;
  window.mangofyDeliveryInitialized = true;
  const config = window.MangofyDeliveryConfig || {};
  const read = key => { try { return localStorage.getItem(key); } catch (_) { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch (_) {} };
  const valid = code => typeof code === 'string' && /^[A-Z]{2}$/.test(code);
  let manuallyChosen = read('country_manual') === '1' && valid(read('country'));
  const manual = () => manuallyChosen;

  function apply(code, force = false) {
    if (!valid(code) || (!force && manual())) return;
    write('country', code);
    if (!window.customElements) return;
    customElements.whenDefined('delivery-wrapper').then(() => {
      if (!force && manual()) return;
      document.querySelectorAll('delivery-wrapper').forEach(wrapper => {
        if (typeof wrapper.changeLocation !== 'function') return;
        wrapper.changeLocation(code);
        if (wrapper.select) wrapper.select.value = code;
        // GB and CN need their own shipping region in the legacy component.
        const region = {GB: 'uk', CN: 'cn'}[code];
        if (region && wrapper.content && typeof wrapper.genDom === 'function') {
          wrapper.location = region.toUpperCase();
          wrapper.estimateArrival = wrapper.content['estimate_arrival_' + region] || '5-7';
          wrapper.orderShip = wrapper.content['order_ship_' + region] || '2-3';
          wrapper.genDom();
        }
      });
    });
  }

  document.addEventListener('click', event => {
    const submit = event.target.closest?.('select-country .submit');
    if (!submit) return;
    const code = submit.closest('select-country')?.querySelector('select')?.value;
    if (!valid(code)) return;
    manuallyChosen = true;
    write('country_manual', '1');
    apply(code, true);
  });

  if (manual() && valid(read('country'))) {
    apply(read('country'), true);
    return;
  }
  // Cache seeds initial display only; a new network must refresh the destination.
  let cached;
  try { cached = JSON.parse(read('country_detected') || 'null'); } catch (_) {}
  apply(config.enabled !== false && valid(cached?.code) ? cached.code : config.country);
  if (config.enabled === false || !config.endpoint) return;
  fetch(config.endpoint, {credentials: 'same-origin'})
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const code = data?.detected_values?.country?.handle;
      if (!valid(code) || manual()) return;
      write('country_detected', JSON.stringify({code, at: Date.now()}));
      apply(code);
    })
    .catch(() => {});
})();
